import React from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useFormContext } from "react-hook-form";
import AdobeScript from '../../../services/adobeScript';

function OverlimitPrivilege() {

    const { register,  formState: { errors } } = useFormContext();    
    const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
    const info = useStoreState((state) => state.applicantModel.applicant);
    const cpLink = useStoreState(state => state.siteSettingsModel.productSettings);
    const adobe = new AdobeScript();
    const Setting = useStoreState((state) => state.siteSettingsModel);
    const overlimitEnabled = Object.values(Setting.websiteSettings || {}).some(
        (feature) => (feature?.Name || "").toLowerCase() === "overlimitsettings"
    );

    const adobeEvent = () => {
        if(info.overlimitConsentValue === ""){
            adobe.event('olp_yes', Setting.CardColors.find(value => value.Code === info.cardColorCode));
        }
    }

    return (
        <div className="col-lg-12">
            
            <div className="container-fluid">
                <div className='row'>
                </div>
                <div className="row credit-protection">
                   
                    <div className="col-lg-12 credit-protection-content">
                    <p><h6>Overlimit refers to any time you exceed the credit limit on your credit card account. If you would like to allow purchases to take you over your credit limit, you must opt-in for the Overlimit Privilege described here.</h6></p>

                    {errors.overlimitConsentValue ? 
                            <div className="error-message mt-1"> You must choose an option before continue. </div>
                            :
                            <></>
                        }                        
                        <div className="form-check check-fields mt-0">
                            <input
                            onClick={(e) => {
                                adobeEvent();
                                setInfo({ index: "overlimitConsentValue", value: e.target.value, });
                                
                                }
                            }
                             name='overlimitConsentValue' className="form-check-input" type="checkbox" value="yes" id="overlimit-privilege-yes"  checked={(info.overlimitConsentValue === "yes" ? true : false)} {...register("overlimitConsentValue", { required: overlimitEnabled })} />
                            <label className="form-check-label" htmlFor="overlimit-privilege-yes">
                                <b>Yes</b>, I want to enroll in the optional Overlimit Privilege.
                            </label>
                        </div>
                        <p className='mt-2'><h6>By selecting YES, I confirm that:</h6></p>
                        <ul>
                            <li>My decision to enroll or not enroll in Overlimit Privilege will not affect my ability to use my credit card or the terms of my Account.</li>
                            <li>I understand that if I exceed my credit limit, I may be charged an Overlimit fee of up to $41 per Billing Cycle.</li>
                            <li>I have read and agree to the <a href={cpLink.OverlimitConsentUrl} target="_blank" rel="noopener noreferrer">Overlimit Privilege Terms and Conditions</a>, which fully discusses the conditions, requirements, and restrictions of the Overlimit coverage.</li>
                            <li>Not all overlimit purchases will be authorized.</li>
                            <li>Enrolling in Overlimit Privilege is optional, and I can cancel this coverage at any time.</li>
                            <li>I understand that I will not be automatically enrolled in Overlimit Privilege unless I select YES.</li>
                        </ul>
                        <div className="form-check check-fields">
                            
                            <input name='overlimitConsentValue' className="form-check-input" type="checkbox" value="no" id="overlimit-privilege-no" checked={(info.overlimitConsentValue === "no" ? true : false)} onClick={(e) => { setInfo({ index: "overlimitConsentValue", value: e.target.value, });  }} {...register("overlimitConsentValue", { required: overlimitEnabled })} />
                            <label className="form-check-label" htmlFor="overlimit-privilege-no" >
                            <b>NO</b>, I am not interested in the Overlimit Privilege.
                        </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default OverlimitPrivilege
